/**
 * NewBadge — small red→orange gradient pill with a soft pulse.
 *
 * Purpose
 *   Marks a game tile as *newly launched*. Admin-driven only — no
 *   auto-expire logic anywhere (product decision: manual toggle is
 *   simpler and works around timezone rollover ambiguity).
 *
 * Placement contract
 *   Always rendered as a top-left absolute overlay INSIDE the game
 *   card container. Tile components pass a `data-testid` prefix so
 *   automated flows can target `<prefix>-new-badge`. NEW never
 *   appears on game detail, play, wallet, or deposit screens — only
 *   on browse/grid tiles.
 *
 * Style
 *   Small pill (24 px tall, 8-9 char max), red→orange linear
 *   gradient, uppercase "NEW" (no exclamation per spec), CSS pulse
 *   animation on `box-shadow` so the badge subtly breathes.
 */
export default function NewBadge({ className = "", testid = "new-badge" }) {
  return (
    <span
      data-testid={testid}
      className={
        "inline-flex items-center justify-center " +
        "px-2 h-5 rounded-full " +
        "text-[9px] font-semibold tracking-[0.28em] text-white " +
        "bg-gradient-to-r from-[#ff3d3d] to-[#ff9138] " +
        "shadow-[0_0_10px_rgba(255,80,60,0.55)] " +
        "new-badge-pulse " +
        className
      }
    >
      NEW
    </span>
  );
}
